import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    firearmAnomalies: [],
    metadata: {},
    isLoading: false,
    firearmAnomalyQueries: {},
}

const FirearmAnomalyReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_FIREARM_ANOMALIES:
            return {
                ...state,
                firearmAnomalies: action.payload?.data,
                metadata: action.payload?.metadata,
            }
        case ClientActionTypes.SET_FIREARM_ANOMALY_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            }
        case ClientActionTypes.SET_FIREARM_ANOMALY_QUERIES:
            return {
                ...state,
                firearmAnomalyQueries: action.payload,
            }

        default:
            return { ...state }
    }
}

export default FirearmAnomalyReducer
